import { Helmet } from "react-helmet-async";
import { LpComparisonTable } from "./components/LpComparisonTable";
import { LpCtaForm } from "./components/LpCtaForm";
import { LpFaq } from "./components/LpFaq";
import { LpFeatures } from "./components/LpFeatures";
import { LpFooter } from "./components/LpFooter";
import { LpHero } from "./components/LpHero";
import { LpImpact } from "./components/LpImpact";
import { LpLogoBand } from "./components/LpLogoBand";
import { LpNavbar } from "./components/LpNavbar";
import { LpOnboarding } from "./components/LpOnboarding";
import { LpPricing } from "./components/LpPricing";
import { LpProblem } from "./components/LpProblem";
import { LpRoiCalculator } from "./components/LpRoiCalculator";
import { LpSecurity } from "./components/LpSecurity";
import { LpSolution } from "./components/LpSolution";
import { LpTestimonials } from "./components/LpTestimonials";
import { lpConfig } from "./lpConfig";
import "./lp.css";

/**
 * StrixSearch ランディングページ
 * @return {JSX.Element} LPページ全体
 */
const LandingPage = () => {
  return (
    <div className="lp-page min-h-screen bg-white text-[#0F1649] overflow-x-hidden">
      <Helmet>
        <title>{lpConfig.meta.title}</title>
        <meta name="description" content={lpConfig.meta.description} />
        <meta name="keywords" content={lpConfig.meta.keywords} />
        <meta property="og:title" content={lpConfig.meta.ogTitle} />
        <meta property="og:description" content={lpConfig.meta.ogDescription} />
        <meta property="og:type" content="website" />
      </Helmet>

      <LpNavbar />
      <main>
        <LpHero />
        <LpLogoBand />
        <LpProblem />
        <LpSolution />
        <LpFeatures />
        <LpSecurity />
        <LpImpact />
        <LpRoiCalculator />
        <LpTestimonials />
        <LpComparisonTable />
        <LpPricing />
        <LpOnboarding />
        <LpFaq />
        <LpCtaForm />
      </main>
      <LpFooter />

      {/* Floating Mobile CTA */}
      <div className="fixed bottom-6 left-6 right-6 z-40 md:hidden">
        <a
          href={lpConfig.floatingCta.href}
          className="w-full bg-[#ff8d00] text-white py-4 rounded-2xl font-bold text-lg shadow-2xl flex items-center justify-center gap-2 active:scale-95 transition-transform"
          style={{ boxShadow: "0 8px 32px rgba(255, 141, 0, 0.4)" }}
        >
          {lpConfig.floatingCta.label}
        </a>
      </div>
    </div>
  );
};

export default LandingPage;
